import { DewiColorsDark9 } from '@styles/tokens/dist/js/tokens'
import {
  DialogProps,
  Slide,
  Dialog as MaterialDialog,
  styled,
} from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { hslStringToRgba } from '@utils/helpers'
import { FC, ReactNode, forwardRef } from 'react'

export const CustomDialog = styled(MaterialDialog)({
  '& .MuiBackdrop-root': {
    backdropFilter: 'blur(5px)',
    background: hslStringToRgba(DewiColorsDark9, 0.5),
  },
  '& .MuiDialog-container': {
    alignItems: 'center',
  },
  '& .MuiDialog-paper': {
    background: 'var(--dewi_colors_dark_7)',
    minWidth: '18.75rem',
    padding: '1.375rem',
    gap: '1.375rem',
    borderRadius: '1.3125rem',
    minHeight: 'var(--dialog-paper-height, auto)',
    transition: 'min-height 0.4s ease-in-out',
    boxSizing: 'content-box',
    overflowY: 'unset',
  },
  '& .MuiDialogContent-root': {
    padding: 0,
    '& .MuiCollapse-root': {
      '& .MuiList-root': {
        background: 'var(--dewi_colors_dark_6)',
      },
    },
    '& .MuiList-root': {
      padding: 0,
    },
  },
  '@media (max-width: 640px)': {
    '& .MuiDialog-container': {
      alignItems: 'flex-end',
    },
    '& .MuiDialog-paper': {
      width: '100%',
      margin: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
})

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />
})

type DewiDialogProps = {
  onExited?: () => void
  children: ReactNode
} & DialogProps

export const Dialog: FC<DewiDialogProps> = ({ ...props }) => {
  const transitionProps = {
    timeout: 500, // Set the duration of the slide-in animation (in milliseconds)
    onExited: props.onExited,
  } as TransitionProps
  return (
    <CustomDialog
      {...props}
      TransitionComponent={Transition}
      TransitionProps={transitionProps}
    >
      {props.children}
    </CustomDialog>
  )
}
